import { NotifyType } from "./notification.model";
export class NavNotificationConstants {
    static ACTIVITY_TEXT = NotifyType.Activity;
    static WARNING_TEXT = NotifyType.Warning;
    static ERROR_TEXT = NotifyType.Error;
    static ALL_TEXT = "All";
    static NEW_TEXT = "NEW";
}
